import { createAsyncThunk } from "@reduxjs/toolkit";
import { get_basket } from "../../../../api/calls/basket/get_basket";
import { setCheckedOutBasket } from "../basket";
import Cookie from "universal-cookie";
export const get_checked_out_basket_thunk = createAsyncThunk("basket/get_checked_out_basket_thunk", async (arg, { dispatch, getState }) => {
    const cookie = new Cookie();
    const state = getState();
    const basketCookie = cookie.get("checked_out_basket");
    // console.log("basketCookie - GET-COOKIE", basketCookie);
    // console.log("get_basket_thunk STATE", state);
    const response = await get_basket({
        user_id: basketCookie.user_id,
        _id: basketCookie._id,
    });
    await response.content.product_list.forEach((product) => {
        if (product.variations && product.variations.length > 0) {
            for (const variation of product.variations) {
                if (variation.variations[0].price) {
                    let price = parseFloat(variation.variations[0].price) + parseFloat(product.price);
                    response.content["product_list"] = response.content.product_list.map((x) => {
                        if (x._id == product._id) {
                            return {
                                ...x,
                                price: price.toFixed(2).toString(),
                            };
                        }
                        return x;
                    });
                }
            }
        }
    });
    dispatch(setCheckedOutBasket(response.content));
    return basketCookie;
});
